module.exports = __webpack_public_path__ + "img/instagram.837c17f4.svg";